import {
	Button,
	Card,
	CardContent,
	CardHeader,
	Checkbox,
	Collapse,
	FormControlLabel,
	Icon,
	IconButton,
	Menu,
	MenuItem,
	Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ExpandMoreOutlined, MoreHorizOutlined } from '@material-ui/icons'
import clsx from 'clsx'
import React, { useEffect, useState } from 'react'
// import { useDispatch } from 'react-redux'
import { ACCESS_TYPES, GLOBAL_ACCESS, PETCARE, GROOMING } from '../../utils'
import StyledChip from '../Common/StyledChip'
import StyledAlert from '../Common/StyledAlert'
import useSelectedFacility from '../../hooks/useSelectedFacility'

const useStyles = makeStyles((theme) => ({
	formWrapper: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between'
	},
	fieldWrapper: {
		marginBottom: '20px',
		'& .MuiTextField-root': {
			minWidth: '275px'
		}
	},
	autoComplete: {
		'& .MuiFilledInput-root': {
			paddingTop: '17px'
		},
		'& .MuiInputLabel-filled': {
			transform: 'translate(12px, 20px) scale(1)'
		},
		'& .Mui-focused': {
			'& .MuiAutocomplete-endAdornment svg': {
				fill: theme.palette.secondary.main
			}
		},
		'& .MuiAutocomplete-endAdornment svg': {
			fill: '#777679'
		}
	},
	card: {
		border: '1px solid #E5E5E5',
		boxShadow: 'none',
		width: '100%',
		marginBottom: 8
	},
	header: {
		padding: '8px 24px',
		'& .MuiCardHeader-action': {
			margin: 0
		},
		'& .MuiCardHeader-title': {
			textTransform: 'none'
		}
	},
	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest
		}),
		padding: 0
	},
	expandOpen: {
		transform: 'rotate(180deg)'
	},
	sectionsWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		flexWrap: 'wrap',
		maxWidth: '68%'
	},
	reportLink: {
		//display: "flex",
		color: '#6B4AD6',
		fontSize: '16px',
		justifyContent: 'flex-start',
		fontWeight: '600',
		'& i': {
			fontSize: '16px',
			marginRight: '16px',
			color: '#6B4AD6',
			lineHeight: '20px'
		},
		'&:hover': {
			textDecoration: 'none'
		}
	},
	switchRoot: {
		width: 51,
		height: 31,
		padding: 0
	},
	switchBase: {
		padding: 0,
		margin: 2,
		'&$checked': {
			transform: 'translateX(20px)',
			color: theme.palette.common.white,
			'& + $track': {
				backgroundColor: '#6B4AD6',
				opacity: 1
			},
			'& .far::before': {
				color: '#6B4AD6'
			}
		},
		'&$focusVisible $thumb': {
			color: '#6B4AD6'
			//border: "6px solid #fff",
		}
	},
	thumb: {
		width: 27,
		height: 27,
		background: '#F3F3F3',
		border: '1px solid #E5E5E5',
		borderRadius: '50%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'& .far': {
			color: '#A2A1A4',
			fontSize: '13px',
			lineHeight: '15px'
		}
	},
	track: {
		borderRadius: 100,
		padding: 2,
		backgroundColor: '#D0CFD2',
		opacity: 1,
		transition: theme.transitions.create(['background-color'])
	},
	checkRow: {
		width: '25%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
		// padding: 12,
	},
	datePicker: {
		marginBottom: 16,
		'& .MuiInputLabel-filled': {
			transform: 'translate(48px, 20px) scale(1)'
		},
		'& .MuiInputLabel-shrink': {
			transform: 'translate(48px, 10px) scale(0.75)'
		}
	},
	int: {},
	viewBtn: {
		padding: 0,
		marginTop: 8,
		marginBottom: 12,
		fontSize: 14,
		fontWeight: '600',
		color: '#6b4ad6',
		textTransform: 'capitalize'
	},
	intRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		paddingTop: 12,
		paddingBottom: 12
	},
	desc: {
		fontSize: 14,
		fontWeight: '700',
		marginRight: 4,
		color: '#4D4C4F'
	},
	descInt: {
		fontSize: 14,
		fontWeight: '600',
		color: '#4D4C4F'
	},
	paper: {
		borderRadius: 6,
		minWidth: 280,
		boxShadow: '0px 2px 15px rgba(26, 26, 53, 0.2)'
	},
	mainCard: {
		'& .MuiCardHeader-action': {
			marginTop: 0,
			marginRight: 0
		}
	}
}))

const EditAddOnBlock = ({ category, facility, showAddOn, triggerSaveBar, shouldReload }) => {
	// const [addOn, setAddOn] = useState({})
	// const dispatch = useDispatch()
	// const [isExpanded, setIsExpanded] = useState(false)
	// const [loading, setLoading] = useState(false)
	// const [isAccessExpanded, setIsAccessExpanded] = useState(false)
	// const [changed, setChanged] = useState(false)
	// const [isStartDateOpen, setIsStartDateOpen] = useState(false)
	// const [startDate, updateStartDate] = useState(null)
	// const [isEndDateOpen, setIsEndDateOpen] = useState(false)
	// const [endDate, updateEndDate] = useState(null)
	const classes = useStyles()

	const [isAvailabilityExpanded, setIsAvailabilityExpanded] = useState(false)
	const [anchorEl, setAnchorEl] = useState(null)
	const [addOns, setAddOns] = useState([])
	const [expandedAddOns, setExpanded] = useState([])
	const [selected, setSelected] = useState({})
	const [expanded, expandBlock] = useState(false)
	const [showInactive, setShowInactive] = useState(false)

	const { updateFeaturedAddon, removeFeaturedAddon } = useSelectedFacility()

	const expand = (id) => {
		if (expandedAddOns.includes(id)) {
			setExpanded(expandedAddOns.filter((i) => i !== id))
		} else {
			setExpanded([...expandedAddOns, id])
		}
	}

	// console.info({ category, addOns })

	const setFeaturedAddon = async ({ addon, service_line }) => {
		// UPDATE FACILITY

		await updateFeaturedAddon({ addon_id: addon._id, service_line })
	}

	const removeFeatured = async ({ addon }) => {
		// UPDATE FACILITY

		await removeFeaturedAddon({ addon_id: addon._id })
	}

	useEffect(() => {
		const addons =
			facility?.add_on_services[category._id]
				?.map((a) => {
					return {
						...a,
						sort_order: !a.active ? 1000 : a.sort_order
					}
				})
				.sort((a, b) => a.sort_order - b.sort_order)
				.map((a, i) => {
					return {
						...a,
						sort_order: a.active ? i : 1000
					}
				}) || []
		setAddOns(addons)
	}, [category, facility, shouldReload])

	const getIconName = (add) => {
		let icon = ''
		if (add.icon) {
			icon = add.icon
		} else {
			icon = 'question-circle'
		}
		return icon
	}

	const getIcon = (add) => {
		let icon = getIconName(add)

		return (
			<div
				onClick={toogleExpand}
				style={{
					width: 48,
					height: 48,
					borderRadius: 24,
					backgroundColor: '#F9F9F9',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
					cursor: 'pointer'
				}}>
				<Icon
					className={`fa fa-${icon}`}
					style={{
						fontWeight: '900',
						fontSize: '16px',
						color: '#270050',
						width: 20
						// overflow: "visible",
					}}
				/>
			</div>
		)
	}

	// const getPrice = (add) => {
	// 	if (add.variable_price) {
	// 		if (add.min_price && add.max_price) {
	// 			return `$${add.min_price / 100} - $${add.max_price / 100}`
	// 		} else {
	// 			return `$${add.price / 100} +`
	// 		}
	// 	} else {
	// 		return `$${add.price / 100}`
	// 	}
	// }

	const getAccess = (add) => {
		if (!add.active) return 'Inactive'
		if (!add.access || add.access === ACCESS_TYPES.GlobalAccess) return ACCESS_TYPES.GlobalAccess
		return ACCESS_TYPES.AdminOnly
	}

	// const daycareTimes = addOn.daycare_time_blocks || []
	// const boardingTimes = addOn.boarding_time_blocks || []

	const handleClick = (event) => {
		event.stopPropagation()
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	const moveUp = () => {
		const num = selected.sort_order - 1
		const adds = addOns
			.map((a) => {
				if (a._id === selected._id)
					return {
						...a,
						sort_order: num < 0 ? 0 : num
					}
				return {
					...a,
					sort_order: a.sort_order === num ? num + 1 : a.sort_order
				}
			})
			.sort((a, b) => a.sort_order - b.sort_order)

		setAddOns(adds)
		handleClose()
		triggerSaveBar(adds)
	}

	const moveDown = () => {
		const num = selected.sort_order + 1
		const adds = addOns
			.map((a, i) => {
				if (a._id === selected._id)
					return {
						...a,
						sort_order: num >= addOns.length ? addOns.length - 1 : num
					}
				return {
					...a,
					sort_order: a.sort_order === num ? num - 1 : a.sort_order
				}
			})
			.sort((a, b) => a.sort_order - b.sort_order)

		setAddOns(adds)
		handleClose()
		triggerSaveBar(adds)
	}

	const toogleExpand = () => expandBlock(!expanded)

	const activeCounts = (() => {
		let val = 0
		addOns.forEach((addon) => {
			if (addon.active) {
				val = val + 1
			}
		})
		return val
	})()

	const inactiveCounts = (() => {
		let val = 0
		addOns.forEach((addon) => {
			if (!addon.active) {
				val = val + 1
			}
		})
		return val
	})()

	const featuredCounts = (() => {
		let val = 0
		addOns.forEach((addon) => {
			if (facility?.featured_addons?.some((a) => a.addon_id === addon._id)) {
				val = val + 1
			}
		})
		return val
	})()

	// Only active enrichments count towards the Signature pills, so the pills never claim an
	// inclusion that the (hidden) inactive list is holding.
	const signatureStayCounts = (() => {
		let val = 0
		addOns.forEach((addon) => {
			if (addon.active && addon.comfort_plus_included) {
				val = val + 1
			}
		})
		return val
	})()

	const signaturePlayCounts = (() => {
		let val = 0
		addOns.forEach((addon) => {
			if (addon.active && addon.signature_play_included) {
				val = val + 1
			}
		})
		return val
	})()

	const facilityFeaturedEnrichmentIds = (() => {
		if (!facility || !facility.featured_addons || facility.featured_addons.length < 1) {
			return []
		}

		return facility.featured_addons.map((featured) => featured.addon_id)
	})()

	const facilityFeaturedPetcareEnrichmentAddonId = (() => {
		if (!facility || !facility.featured_addons || facility.featured_addons.length < 1) {
			return ''
		}

		const featured = facility?.featured_addons?.find((add) => add.service_line === PETCARE)

		return featured ? featured.addon_id : ''
	})()

	const facilityFeaturedGroomingEnrichmentAddonId = (() => {
		if (!facility || !facility.featured_addons || facility.featured_addons.length < 1) {
			return ''
		}

		const featured = facility?.featured_addons?.find((add) => add.service_line === GROOMING)

		return featured ? featured.addon_id : ''
	})()

	return (
		<Card style={{ marginTop: '0px', marginBottom: '24px' }} className={classes.mainCard} key={category?.name}>
			<Menu
				elevation={2}
				getContentAnchorEl={null}
				id="customized-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right'
				}}
				classes={{ paper: classes.paper }}>
				<MenuItem
					onClick={(e) => {
						if (selected) showAddOn(selected)
						handleClose()
					}}>
					<i className="fas fa-edit" style={{ marginRight: 12 }} /> Edit enrichment
				</MenuItem>
				<MenuItem
					disabled={selected && !selected.active}
					onClick={(e) => {
						moveUp()
					}}>
					<i className="far fa-arrow-to-top" style={{ marginRight: 12 }} /> Move up in order
				</MenuItem>
				<MenuItem
					disabled={selected && !selected.active}
					onClick={(e) => {
						moveDown()
					}}>
					<i className="far fa-arrow-to-bottom" style={{ marginRight: 12 }} />
					Move down in order
				</MenuItem>
			</Menu>
			<CardHeader
				avatar={getIcon(category)}
				title={
					<div
						onClick={toogleExpand}
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'flex-start',
							alignItems: 'flex-start',
							cursor: 'pointer',
							gap: '1rem'
						}}>
						<Typography
							variant="body2"
							style={{
								fontWeight: '800',
								color: '#270050',
								fontSize: 16,
								flex: 1
							}}>
							{category.name}
						</Typography>
						<StyledChip
							skiptownvariant={'successes'}
							label={
								<div>
									<span style={{ fontWeight: '800' }}>{activeCounts}</span>
									<span> Active</span>
								</div>
							}></StyledChip>
						{inactiveCounts > 0 ? (
							<StyledChip
								skiptownvariant={'gray'}
								label={
									<div>
										<span style={{ fontWeight: '800' }}>{inactiveCounts}</span>
										<span> Inactive</span>
									</div>
								}></StyledChip>
						) : null}
						{featuredCounts > 0 ? (
							<StyledChip
								skiptownvariant={'purple'}
								label={
									<div>
										<span style={{ fontWeight: '800' }}>{featuredCounts}</span>
										<span> Featured</span>
									</div>
								}></StyledChip>
						) : null}
						{signatureStayCounts > 0 ? (
							<StyledChip
								skiptownvariant={'warnings'}
								label={
									<div>
										<span style={{ fontWeight: '800' }}>{signatureStayCounts}</span>
										<span> Signature Stay</span>
									</div>
								}></StyledChip>
						) : null}
						{signaturePlayCounts > 0 ? (
							<StyledChip
								skiptownvariant={'purple'}
								label={
									<div>
										<span style={{ fontWeight: '800' }}>{signaturePlayCounts}</span>
										<span> Signature Play</span>
									</div>
								}></StyledChip>
						) : null}
					</div>
				}
				action={
					<div
						style={{
							display: 'flex',
							padding: 12,
							flexDirection: 'row',
							justifyContent: 'space-between',
							alignItems: 'center'
						}}>
						{expanded && (
							<div>
								<FormControlLabel
									style={{
										fontSize: 16,
										fontWeight: '600',
										color: '#1a1a35'
									}}
									control={
										<Checkbox
											checked={showInactive}
											onChange={(e) => {
												e.stopPropagation()
												setShowInactive(!showInactive)
											}}
										/>
									}
									label="Show inactive enrichments"
								/>
							</div>
						)}
						<IconButton
							size="medium"
							className={clsx(classes.expand, {
								[classes.expandOpen]: expanded
							})}
							onClick={toogleExpand}
							aria-expanded={expanded}
							aria-label="show more">
							<ExpandMoreOutlined style={{ fill: '#777679' }} fontSize="large" />
						</IconButton>
					</div>
				}
			/>
			<Collapse in={expanded}>
				<CardContent>
					<div className={classes.formWrapper}>
						{addOns
							.filter((a) => {
								if (!showInactive) return !!a.active
								return true
							})
							.map((a, i) => {
								const hideFeaturedEnrichmentToggle = a.access !== GLOBAL_ACCESS || !a.active
								const featuredEnrichmentServiceLine = a.grooming_service ? GROOMING : PETCARE
								const existingFeaturedForServiceLine = a.grooming_service
									? facilityFeaturedGroomingEnrichmentAddonId
									: facilityFeaturedPetcareEnrichmentAddonId
								const cannotBeFeaturedEnrichment =
									a.access !== GLOBAL_ACCESS ||
									!a.active ||
									!a.image_url ||
									!a.description ||
									a.description === '' ||
									existingFeaturedForServiceLine > ''
								const featuredEnrichmentIssues = []
								if (!a.image_url) {
									featuredEnrichmentIssues.push({ message: 'Photo missing', type: 'error' })
								}
								if (!a.description || a.description === '') {
									featuredEnrichmentIssues.push({ message: 'No description', type: 'error' })
								}
								const isCurrentlyFeatured = facilityFeaturedEnrichmentIds.includes(a._id)
								return (
									<Card className={classes.card} key={`block-${i}`}>
										<CardHeader
											className={classes.header}
											title={
												<div>
													{`${a.name}`}
													<IconButton
														className={clsx(classes.expand, {
															[classes.expandOpen]: isAvailabilityExpanded
														})}
														style={{ backgroundColor: '#F9F9F9', marginLeft: 12 }}
														onClick={(e) => {
															handleClick(e)
															setSelected(a)
														}}
														aria-expanded={isAvailabilityExpanded}
														aria-label="show more">
														<MoreHorizOutlined style={{ fill: '#280050' }} />
													</IconButton>
													{!a.active && (
														<Typography
															variant="body1"
															component="span"
															style={{
																marginLeft: 12,
																backgroundColor: '#F3F3F3',
																padding: 4,
																borderRadius: 4,
																color: '#4D4C4F',
																fontSize: 14,
																fontWeight: '400'
															}}>
															Inactive
														</Typography>
													)}
													{isCurrentlyFeatured ? (
														<StyledChip
															skiptownvariant="purple"
															label="Featured"
															style={{ marginLeft: '.8rem' }}
														/>
													) : null}
													{a.comfort_plus_included ? (
														<StyledChip
															skiptownvariant="warnings"
															label="Signature Stay"
															style={{ marginLeft: '.8rem' }}
														/>
													) : null}
													{a.signature_play_included ? (
														<StyledChip
															skiptownvariant="purple"
															label="Signature Play"
															style={{ marginLeft: '.8rem' }}
														/>
													) : null}
												</div>
											}
											onClick={() => expand(a._id)}
											action={
												<div
													style={{
														display: 'flex',
														flexDirection: 'row',
														justifyContent: 'space-between',
														alignItems: 'center'
													}}>
													<IconButton
														className={clsx(classes.expand, {
															[classes.expandOpen]: isAvailabilityExpanded
														})}
														onClick={() => expand(a._id)}
														aria-expanded={isAvailabilityExpanded}
														aria-label="show more">
														<ExpandMoreOutlined style={{ fill: '#777679' }} />
													</IconButton>
												</div>
											}
										/>
										<Collapse in={expandedAddOns.includes(a._id)} timeout="auto" unmountOnExit>
											<CardContent>
												<div className={classes.int}>
													<Button
														variant="text"
														className={classes.viewBtn}
														onClick={() => showAddOn(a)}>
														View All Details
													</Button>
													<div className={classes.intRow}>
														<Typography variant="body1" className={classes.desc}>
															Access:{' '}
														</Typography>
														<Typography variant="body1" className={classes.descInt}>
															{getAccess(a)}
														</Typography>
													</div>
													<div className={classes.intRow}>
														<Typography variant="body1" className={classes.desc}>
															Availability:{' '}
														</Typography>
														<Typography variant="body1" className={classes.descInt}>
															{a.limited ? 'Limited' : 'Unlimited'}
														</Typography>
													</div>
													<div className={classes.intRow}>
														<Typography variant="body1" className={classes.desc}>
															Pricing:{' '}
														</Typography>
														<Typography variant="body1" className={classes.descInt}>
															{a.variable_price
																? `$${(a.min_price / 100).toFixed(2)} - $${(
																		a.max_price / 100
																  ).toFixed(2)}`
																: `$${(a.price / 100).toFixed(2)}`}
														</Typography>
													</div>
													{!hideFeaturedEnrichmentToggle ? (
														<div className={classes.intRow}>
															<FormControlLabel
																style={{
																	fontSize: 11,
																	fontWeight: '600',
																	color: '#1a1a35'
																}}
																control={
																	<Checkbox
																		checked={isCurrentlyFeatured}
																		disabled={
																			!isCurrentlyFeatured &&
																			cannotBeFeaturedEnrichment
																		}
																		onChange={(e) => {
																			e.stopPropagation()
																			if (isCurrentlyFeatured) {
																				removeFeatured({ addon: a })
																			} else {
																				setFeaturedAddon({
																					addon: a,
																					service_line: featuredEnrichmentServiceLine
																				})
																			}
																		}}
																	/>
																}
																label={
																	<Typography
																		variant="body1"
																		className={classes.descInt}>
																		Featured Enrichment
																	</Typography>
																}
															/>
															{featuredEnrichmentIssues.map((issue) => {
																return (
																	<StyledAlert
																		type={issue.type}
																		text={issue.message}
																	/>
																)
															})}
														</div>
													) : null}
												</div>
											</CardContent>
										</Collapse>
									</Card>
								)
							})}
					</div>
				</CardContent>
			</Collapse>
		</Card>
	)
}

export default EditAddOnBlock
